export type EcomailWidgets = {
    desktop: string
    mobile: string
}

const slovakWidgets: EcomailWidgets = {
    desktop: '1-43c2cd496486bcc27217c3e790fb4088',
    mobile: '2-2bb287d15897fe2f9d89c882af9a3a8b'
}
const slovakEnglishWidgets: EcomailWidgets = {
    desktop: '4-f67e22c6c3dacfc9b77b6b40399abc16',
    mobile: '2-2bb287d15897fe2f9d89c882af9a3a8b'
}
const czechWidgets: EcomailWidgets = {
    desktop: '4-f67e22c6c3dacfc9b77b6b40399abc16',
    mobile: '3-b6fcc542fb021c84fdaff536dd0a74a1'
}
const czechEnglishWidgets: EcomailWidgets = {
    desktop: '5-ed07fd6b07ff0199fabc8509f995f058',
    mobile: '7-c01458c4e85a58f0047857fac06ae283'
}

export const getEcomailAccount = (country: string): string | null => {
    if (country === 'CZE') return 'boxylandcz'
    if (country === 'SVK') return 'boxyland'
    return null
}

export const getEcomailWidgets = (
    country: string,
    language: string
): EcomailWidgets | null => {
    if (country === 'CZE') {
        if (language === 'CS') return czechWidgets
        if (language === 'EN') return czechEnglishWidgets
    }
    if (country === 'SVK') {
        if (language === 'SK') return slovakWidgets
        if (language === 'EN') return slovakEnglishWidgets
    }
    return null
}

const allWidgets = [
    slovakWidgets,
    slovakEnglishWidgets,
    czechWidgets,
    czechEnglishWidgets
]
export const ecomailWidgetIds = Array.from(
    new Set(allWidgets.flatMap(widgets => [widgets.desktop, widgets.mobile]))
)
export const ecomailDesktopSelector = `:is(${Array.from(
    new Set(allWidgets.map(widgets => `#ec_form_${widgets.desktop}`))
).join(', ')})`
export const ecomailMobileSelector = `:is(${Array.from(
    new Set(allWidgets.map(widgets => `#ec_form_${widgets.mobile}`))
).join(', ')})`
